/**
 * talk·point — <tp-readmore>
 * Klappt reichen HTML-Inhalt (Produktbeschreibung) ein: zeigt nur den Anfang,
 * darunter ein "mehr ▾ / weniger ▴"-Button. Formatierung (Listen, Fett, Absätze)
 * bleibt erhalten — geclippt wird über die Höhe (kein strip_html, kein Marker
 * nötig). Passt der Inhalt ohnehin in die Klapphöhe, erscheint kein Button.
 *
 * Markup:
 *   <tp-readmore data-clamp="240"><div class="tp-desc">…HTML…</div></tp-readmore>
 *
 * Bewusst import-frei (kein Modul).
 */
(function () {
  if (customElements.get('tp-readmore')) return;

  class TpReadmore extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.tp-desc') || this.firstElementChild;
      if (!this.content || this._init) return;
      this._init = true;
      var collapsed = parseInt(this.getAttribute('data-clamp') || '240', 10);
      this.style.setProperty('--tp-clamp', collapsed + 'px');
      // Nach dem Layout messen, ob überhaupt geklappt werden muss.
      var self = this;
      requestAnimationFrame(function () {
        // +24px Toleranz: knapp passende Texte nicht unnötig clampen.
        if (self.content.scrollHeight <= collapsed + 24) return;
        self.classList.add('is-clamped');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tp-readmore__btn';
        btn.setAttribute('aria-expanded', 'false');
        self.btn = btn;
        self.label(false);
        btn.addEventListener('click', function () {
          var open = self.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', String(open));
          self.label(open);
        });
        // Knopfzeile (z. B. mit dem loadbee-Knopf daneben) → „mehr" vorne einreihen
        var row = self.querySelector('.tp-readmore__row');
        if (row) row.prepend(btn); else self.appendChild(btn);
      });
    }
    label(open) {
      this.btn.innerHTML = open
        ? 'weniger <span class="tp-readmore__chev" aria-hidden="true">▴</span>'
        : 'mehr <span class="tp-readmore__chev" aria-hidden="true">▾</span>';
    }
  }

  customElements.define('tp-readmore', TpReadmore);
})();
